export default {
  category: {
    id: 'international_onboarding_shipping_recap_category',
    defaultMessage: 'Category',
  },
  carrier: {
    id: 'international_onboarding_shipping_recap_carrier',
    defaultMessage: 'Carrier',
  },
  shippingDelay: {
    id: 'international_onboarding_shipping_recap_shipping_delay',
    defaultMessage: 'Shipping delay',
  },
  shippingDelayValueInHour: {
    id: 'international_onboarding_shipping_recap_shipping_delay_value_in_hour',
    defaultMessage: '{number}h',
  },
  cost: {
    id: 'international_onboarding_shipping_recap_cost',
    defaultMessage: 'Cost',
  },
  free: {
    id: 'international_onboarding_shipping_recap_free',
    defaultMessage: 'Free',
  },
  allCategories: {
    id: 'international_onboarding_shipping_all_categories',
    defaultMessage: 'All categories',
  },
  otherCategories: {
    id: 'international_onboarding_shipping_other_categories',
    defaultMessage: 'Other categories',
  },
  delete: {
    id: 'international_onboarding_shipping_delete',
    defaultMessage: 'Delete',
  },
  edit: {
    id: 'international_onboarding_shipping_edit',
    defaultMessage: 'Edit',
  },
} as const
